import moment from "moment-timezone";
export const clicksTable = (data = []) => {
    return (
        data &&
        data.length &&
        data.map((item, index) => {
            const {
                campaign_id,
                account_name,
                browser,
                campaign_name,
                ip,
                is_banned,
                created_at,
                device,
                os,
                country_code,
                country_name,
            } = item;

            return {
                rowId: index + 1,
                created_at,
                is_banned,
                device,
                ip,
                os,
                browser,
                account_name,
                campaign_name,
                country_code: country_code.toUpperCase(),
                country_name,
            };
        })
    );
};

export const clicksTableTitles = () => {
    return [
        {
            title: "IP",
            alias: "ip",
        },
        {
            title: "Account",
            alias: "account",
        },
        {
            title: "Campaign",
            alias: "campaign",
        },
        {
            title: "Clicked on",
            alias: "created_at",
        },
        {
            title: "Detected",
            alias: "detected",
        },
    ];
};
